import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  successMessage: undefined,
  errorMessage: undefined,
};

const drmCoupaExpireSlice = createSlice({
  name: "drmCoupaExpire",
  initialState,
  reducers: {
    expireCoupaFilesStart: (state) => {
      state.isLoading = true;
      state.successMessage = undefined;
      state.errorMessage = undefined;
    },
    expireCoupaFilesSuccess: (state, action) => {
      state.isLoading = false;
      state.successMessage = action.payload;
    },
    expireCoupaFilesFailure: (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload;
    },
    resetExpireCoupaFilesState: () => ({ ...initialState }),
  },
});

export const {
  expireCoupaFilesStart,
  expireCoupaFilesSuccess,
  expireCoupaFilesFailure,
  resetExpireCoupaFilesState,
} = drmCoupaExpireSlice.actions;

export default drmCoupaExpireSlice.reducer;
